import { Box, Container, Grid2 as Grid } from '@mui/material';

import { ProfileCard } from './ProfileCard';
import { ResumeCard } from './ResumeCard';
import { ExperienceCard } from './ExperienceCard';
import { EducationCard } from './EducationCard';
import { ReferencesCard } from './ReferencesCard';
import { AssociationsCard } from './AssociationsCard';
import { CertificatesCard } from './CertificatesCard';
import { VideosCard } from './VideosCard';
import { ApplicationsCard } from './ApplicationsCard';
import { SavedPostsCard } from './SavedPostsCard';

export const JobseekerProfile = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 12 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 9 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <ProfileCard />
            <VideosCard />
            <ResumeCard />
            <ExperienceCard />
            <EducationCard />
            <ReferencesCard />
            <AssociationsCard />
            <CertificatesCard />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <ApplicationsCard />
            <SavedPostsCard />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};
